import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { goBackAction, needHelpAction } from './actions';
import { getDateMonthYearFromEpoch, getISTTime, isFromJsSDK } from "../../../configs/utils";
export const template = (height, pledgeDetails, pendingForeclosureStepperData, pledgedDate, target, fromInProgressProcess) => {
    return {
        layout: {
            id: ROUTE.PLEDGE_DETAILS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "pledgeDetailsDC", type: WIDGET.PLEDGE_DETAILS }
            ],
        },
        datastore: {
            pledgeDetailsDC: {
                height: height,
                goBackAction: {
                    routeId: ROUTE.PLEDGE_DETAILS,
                    payload: {
                        fromInProgressProcess: fromInProgressProcess
                    },
                    type: ACTION.GO_BACK_ACTION
                },
                needHelpAction: {
                    routeId: ROUTE.PLEDGE_DETAILS,
                    payload: {},
                    type: ACTION.NEED_HELP_ACTION
                },
                pledgeDetails: target ? target[0] : pledgeDetails,
                pendingForeclosureStepperData: pendingForeclosureStepperData,
                pledgedDate: pledgedDate
            },
        }
    };
};
export const pledgeDetailsMF = {
    onLoad: async ({ getHeight, removeWidgets }, { pledgeDetails, target, targetDataSDK, fromInProgressProcess }) => {
        const _target = isFromJsSDK()
            ? targetDataSDK
            : target;
        const pledgeDetailsCreatedOn = _target ? _target[0]?.createdOn : pledgeDetails?.createdOn;
        const dateAndMonth = getDateMonthYearFromEpoch(pledgeDetailsCreatedOn).slice(0, -6);
        const pledgedDate = `${getISTTime(pledgeDetailsCreatedOn)}, ${dateAndMonth}`;
        await removeWidgets(ROUTE.PLEDGE_DETAILS, [
            { id: "pledgeDetailsDC", type: WIDGET.PLEDGE_DETAILS }
        ]);
        const pledgedDetailsStatus = pledgeDetails?.status;
        const pledgedOnlyDate = getDateMonthYearFromEpoch(pledgeDetailsCreatedOn);
        let secondStepperStatus;
        if (pledgedDetailsStatus === "SUCCESS") {
            secondStepperStatus = "COMPLETED";
        }
        else if (pledgedDetailsStatus === "FAILED") {
            secondStepperStatus = "FAILED";
        }
        else {
            secondStepperStatus = "IN_PROGRESS";
        }
        const secondStepperFailedText = "For more details contact support";
        const secondStepperOtherDescriptionText = "Your request is being processed for approval";
        const thirdStepperFailedText = "SEBI authorised RTAs (CAMS and KFintech) will be notified to remove pledge from your portfolio.";
        const thirdStepperSuccessText = "SEBI authorised RTAs (CAMS and KFintech) have been notified. It may take them 4-5 business days to remove pledge.";
        const thirdStepperInProgressText = "SEBI authorised RTAs (CAMS and KFintech) will be notified to remove pledge from your portfolio.";
        const pendingForeclosureStepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Unpledge request submitted",
                "verticalDescription": `Placed by you at ${pledgedDate}`,
                "order": 0,
                "highLightText": false
            },
            {
                "status": secondStepperStatus,
                "verticalDisplayName": pledgedDetailsStatus === "FAILED" ? "Unpledge request rejected" : "Unpledge request under approval",
                "verticalDescription": pledgedDetailsStatus === "FAILED" ? secondStepperFailedText : secondStepperOtherDescriptionText,
                "order": 1,
                "highLightText": pledgedDetailsStatus !== "SUCCESS"
            },
            {
                "status": pledgedDetailsStatus === "SUCCESS" ? "COMPLETED" : pledgedDetailsStatus === "FAILED" ? "FAILED" : "WHATEVER",
                "verticalDisplayName": "RTA(s) will remove pledge",
                "verticalDescription": pledgedDetailsStatus === "FAILED" ? thirdStepperFailedText : pledgedDetailsStatus === "SUCCESS" ? thirdStepperSuccessText : thirdStepperInProgressText,
                "order": 2,
                "doNotHighlightImage": true,
                "highLightText": pledgedDetailsStatus === "SUCCESS"
            },
        ];
        return Promise.resolve(template(getHeight(), pledgeDetails, pendingForeclosureStepperData, pledgedOnlyDate, _target, fromInProgressProcess));
    },
    actions: {
        [ACTION.GO_BACK_ACTION]: goBackAction,
        [ACTION.NEED_HELP_ACTION]: needHelpAction,
    },
};
